import { render, staticRenderFns } from "./ota-order.vue?vue&type=template&id=32c4fff2&scoped=true"
import script from "./ota-order.vue?vue&type=script&lang=ts"
export * from "./ota-order.vue?vue&type=script&lang=ts"
import style0 from "./ota-order.vue?vue&type=style&index=0&id=32c4fff2&prod&lang=css"
import style1 from "./ota-order.vue?vue&type=style&index=1&id=32c4fff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c4fff2",
  null
  
)

export default component.exports